var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrabber = function SvgGrabber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.938 9.625a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25m0-3.75a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25m1.124-2.625a1.125 1.125 0 1 0-2.25 0 1.125 1.125 0 0 0 2.25 0M5.063 9.625a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25m0-3.75a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25M6.188 3.25a1.125 1.125 0 1 0-2.25 0 1.125 1.125 0 0 0 2.25 0"
  })));
};
export default SvgGrabber;